import React, { useState } from "react";

import { SignupContainerFactoryImpl } from "../../../business";
import { AccountStrings } from "../../../business/core";
import { AccountContainerComponent } from "../components";

export const SignupPage: React.FC = () => {
    const cs = AccountStrings['PTBR'].signup;
    const [step, setStep] = useState(1);
    const [signupFormData, setSignupFormData] = useState<FormData>();
    const factory = new SignupContainerFactoryImpl(step, setStep, signupFormData, setSignupFormData);

    return (
        <AccountContainerComponent title={cs.title}>
            {factory.create()}
        </AccountContainerComponent>
    );
};
